import { connect } from 'react-redux'
import { LoginWrapper } from './LoginWrapper'

const LoginWrapperContainer = connect(() => ({}))(LoginWrapper)

export {
  LoginWrapperContainer
}
